module.exports = __webpack_public_path__ + "static/media/soma.6c6320a0.svg";